"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _useInterval = _interopRequireDefault(require("../hooks/useInterval"));

var _Quips = _interopRequireDefault(require("../constants/Quips"));

var _LanguageUtil = _interopRequireDefault(require("../util/LanguageUtil"));

var quipDelay = 5000;
var ENGLISH_LANG = 'en';

var _default = function _default() {
  var getQuip = function getQuip() {
    var pick = Math.floor(Math.random() * _Quips.default.length); // Remove quip so it's not reused and return it

    return _Quips.default.length && _LanguageUtil.default.getUserLanguage() === ENGLISH_LANG ? _Quips.default.splice(pick, 1) : _I18n.default.text('results.loading.text');
  };

  var _useState = (0, _react.useState)(getQuip()),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      quip = _useState2[0],
      setQuip = _useState2[1];

  (0, _useInterval.default)(function () {
    return setQuip(getQuip());
  }, quipDelay);
  return _react.default.createElement("span", null, quip);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Quips.js
// module id = 294
// module chunks = 0